import { LitElement, html } from './-global.min.js'

class HHLoadMore extends LitElement {
  static properties = {
    url: {
      type: String,
    },
    position: {
      type: String,
    },
    'target-class': {
      type: String,
    },
  }

  constructor() {
    super()
    this.position = 'next'
  }

  connectedCallback() {
    super.connectedCallback()
    this.addEventListener('submit', this.handleLoadMore.bind(this))
  }

  disconnectedCallback() {
    super.disconnectedCallback()
  }

  async handleLoadMore(e) {
    e.preventDefault()
    try {
      const url = this['url']
      const targetClass = this['target-class']

      this.setButtonLoading()

      if (this.position === 'next') {
        // this.setPageUrl(url)
      }

      const res = await fetch(url)
      const data = await res.text()
      const dataDom = await new DOMParser().parseFromString(data, 'text/html')

      const newData = dataDom.querySelector(targetClass)
      document
        .querySelector(targetClass)
        .insertAdjacentHTML(
          this.position === 'previous' ? 'afterbegin' : 'beforeend',
          newData.innerHTML
        )

      this.rerenderComponent(dataDom)
      this.focusOnNewContent(newData)
    } catch (error) {
      console.error(error)
    }
  }

  setButtonLoading() {
    const buttonEl = this.querySelector('.js-load-more, button[type="submit]')

    buttonEl.classList.add('is-loading')
    buttonEl.setAttribute('disabled', true)
  }

  rerenderComponent(data) {
    if (!data) return
    const elId = `#${this.getAttribute('id')}`

    const newLoadMore = data.querySelector(elId)?.outerHTML || ''
    this.outerHTML = newLoadMore
  }

  setPageUrl(url) {
    window.history.pushState({}, '', url)
  }

  focusOnNewContent(data) {
    if (!data) return
    const targetClass = this['target-class']
    const focusableSelector =
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'

    const container = document.querySelector(targetClass)
    const focusableFromContainer = container.querySelectorAll(focusableSelector)

    const focusableFromData = data.querySelector(focusableSelector)

    const firstFocusable = Array.from(focusableFromContainer).find((item) => {
      return item.isEqualNode(focusableFromData)
    })

    setTimeout(() => {
      firstFocusable?.focus()
    }, 10);
  }

  render() {
    return html` <slot></slot> `
  }
}

customElements.define('hh-load-more', HHLoadMore)
